import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchProductNewest = createAsyncThunk(
  "newest/fetchProductNewest",
  async ({ lang, page = 1 }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/products/newest`, {
        headers: {
          "Accept-Language": lang || "en",
        },
        params: {
          page,
          per_page: 10, 
        },
      });

      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to fetch product newest";
      return rejectWithValue({ message });
    }
  }
);
